import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "data-name": "Group 4209" }, [
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8005",
    d: "M10.692 8.697H9.308v6.229h1.384z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8006",
    d: "M10 7.095a1.038 1.038 0 1 0-1.038-1.038A1.038 1.038 0 0 0 10 7.095z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "data-name": "Path 8007",
    d: "M10 0a10 10 0 1 0 7.071 2.929A10 10 0 0 0 10 0zm0 18.571a8.571 8.571 0 1 1 6.061-2.51A8.571 8.571 0 0 1 10 18.571z"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render };